import React from 'react';
import { max } from 'js-media-query';
import { Ui }from '@einstein/schedule-platform';

import {
  Section,
  Container,
  Wrapper,
  TextContainer,
  Title,
  Description,
  ViewMore,
  ButtonContainer,
  ImageSection,
  WrapperGrid,
  Card
} from './styles';

const Image =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Vaccine/image.png';
const Image2x =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Vaccine/image@2x.png';
const CarIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/car.svg';
const HouseIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/house.svg';
const LocationIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/location.svg';

type VaccineProps = {
  handleSchedule: () => void;
  hasProductError?: boolean;
};

const Vaccine = ({ handleSchedule, hasProductError }: VaccineProps) => {
  return (
    <Section id="imunizacao">
      <Container>
        <Wrapper>
          <ImageSection src={max(900) ? Image : Image2x} />
          <TextContainer>
            <Title>Vacina da gripe</Title>
            <Description>
              A vacina da gripe é muito importante para proteger a nós e nossa
              família, porque previne a disseminação do vírus, além de evitar
              complicações e hospitalizações.
            </Description>
            <ViewMore>Veja abaixo quais as formas de atendimento.</ViewMore>
            <ButtonContainer>
              <Ui.Button
                title={
                  !hasProductError ? 'Agendar' : 'Agendamento não disponível'
                }
                disabled={!!hasProductError}
                onClick={handleSchedule}
                tertiary={!max(900)}
              />
            </ButtonContainer>
          </TextContainer>
        </Wrapper>
        <WrapperGrid>
          <Card>
            <div>
              <img src={LocationIcon} alt="" />
              <h1>Presencial</h1>
            </div>
            <p>Escolha a unidade mais próxima para se vacinar.</p>
          </Card>
          <Card>
            <div>
              <img src={CarIcon} alt="" />
              <h1>Drive-thru</h1>
            </div>
            <p>Escolha a unidade, aguarde no carro e receba a sua vacina.</p>
          </Card>
          <Card>
            <div>
              <img src={HouseIcon} alt="" />
              <h1>Einstein até você</h1>
            </div>
            <p>Receba a vacina da gripe no conforto da sua casa.</p>
          </Card>
        </WrapperGrid>
      </Container>
    </Section>
  );
};

export default Vaccine;
